var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ResetPassword',{attrs:{"email":_vm.email,"loading":_vm.sendingPasswordEmail,"form-error":_vm.resetPasswordEmailError,"errors":_vm.$v,"success-message":_vm.successMessage,"disable":_vm.sentEmail || _vm.sendingPasswordEmail},on:{"update:email":_vm.updateEmail,"logIn":_vm.logIn,"sendResetPasswordEmail":_vm.sendEmail}})
}
var staticRenderFns = []

export { render, staticRenderFns }